<template>
  <div class="follower-card">
    <div class="right-div">
      <img class="image-loading avatar-img" :src="follower.avatar" alt="" />
      <div class="user-name-div">
        <p class="name">{{ follower.name }}</p>
        <p class="username">{{ follower.userName }}</p>
      </div>
    </div>
    <div class="left-div">
      <a
        :href="'/chat/' + follower.chatLink"
        class="chat-btn"
        v-if="follower.chatLink"
        >گفتگو</a
      >
      <a
        :href="'/' + follower.witrinoLink"
        class="witrino-btn"
        v-if="follower.witrinoLink"
        >ویترین</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "followerCard",
  props: {
    follower: Object,
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/followerCard/followerCard.css);
</style>